import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";

import formData from './modules/form-data';
import configuration from "./modules/configuration";
import userData from './modules/user-data'
import tokenCounter from './modules/token-counter'

Vue.use(Vuex);

export default new Vuex.Store({
    strict: true,
    plugins: [
        createPersistedState({
            paths: ['formData', 'configuration'],
            storage: window.sessionStorage,
        }),
        createPersistedState({
            paths: ['userData'],
            storage: window.localStorage,
        }),
    ],
    modules: {
        formData,
        configuration,
        userData,
        tokenCounter
    },
})

